module.exports = __webpack_public_path__ + "static/media/shoppingtirol.19e9ebe8.jpg";